'use strict'

const logoMiddle = document.querySelector('.js-middle-logo.js-logo-moves-up');

if (logoMiddle != null) {
  const color1 = logoMiddle.dataset.gradientStart;
  const color2 = logoMiddle.dataset.gradientEnd;
  const hex = function(x) {
      x = x.toString(16);
      return (x.length == 1) ? '0' + x : x;
  };

  function logoOnScroll() {
    const scroll = window.pageYOffset;
    let scrollRatio = scroll*2/window.innerHeight;
    if(scrollRatio > 1) scrollRatio = 1;
    if(scrollRatio <=1 ) {

      const scale = 1.583 - 0.583*scrollRatio;
  
      const r = Math.ceil(parseInt(color1.substring(0,2), 16) * (1-scrollRatio) + parseInt(color2.substring(0,2), 16) * scrollRatio);
      const g = Math.ceil(parseInt(color1.substring(2,4), 16) * (1-scrollRatio) + parseInt(color2.substring(2,4), 16) * scrollRatio);
      const b = Math.ceil(parseInt(color1.substring(4,6), 16) * (1-scrollRatio) + parseInt(color2.substring(4,6), 16) * scrollRatio);
  
      const middle = hex(r) + hex(g) + hex(b);
      const svg = logoMiddle.querySelector('svg');
      svg.setAttribute('fill',`#${middle}`);
  
      if(window.innerWidth > 768) {
        logoMiddle.style.transform = `translateX(-50%) scale(${scale})`;
      } else {
        logoMiddle.style.transform = `translateX(-50%) scale(${scale})`;
      }

      const annBar = document.querySelector('.shopify-section.ann-bar-section');
      const annBarHeight = annBar ? annBar.offsetHeight : 0
  
      if (window.innerWidth > 768) {
        const topDist = 30 + ((window.innerHeight/2 - (30+annBarHeight) - logoMiddle.offsetHeight/2)*(1-scrollRatio));
        logoMiddle.style.top = `${topDist}px`;
        logoMiddle.style.position = `absoulte`;
      } else {
        const topDist = 14 + ((window.innerHeight/2 - (14+annBarHeight) - logoMiddle.offsetHeight/2)*(1-scrollRatio));
        logoMiddle.style.top = `${topDist}px`;
        logoMiddle.style.position = `absoulte`;
      }
    }
  }

  logoOnScroll();

  window.addEventListener('scroll', logoOnScroll);
  window.addEventListener('custom:ann-bar-closed',logoOnScroll);
} else if(logoMiddle!==null) {
  logoMiddle.classList.remove('js-middle-logo');
}